import UrlGenerator from '../../Infrastructure/Routing/UrlGenerator';

export const getSignupUrl = (query?: URLSearchParams) => {
  const appUrl = UrlGenerator().appRoot();
  const signupUrl = UrlGenerator().signupRoot();

  const intended = query?.get('intended');
  const flow = query?.get('flow');

  if (!intended || flow !== 'oauth') {
    return signupUrl;
  }

  const redirectUrl = encodeURIComponent(`${appUrl}${intended}`);
  return `${signupUrl}?redirect_url=${redirectUrl}`;
};
